import { Component, Output, EventEmitter, Input } from '@angular/core';
import { LoaderSpinnerComponent } from '@aston/foundation/components';
import { ActionType, IAction, Loader } from '@aston/foundation';
import { TranslateDirective } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';
import { Observable } from 'rxjs';

import { CommentsBlockComponent } from '../../../comments-module/components/comments-block/comments-block.component';
import { ICommentItem } from '../../../comments-module/models';

@Component({
	selector: 'dunning-accounting-discuss',
	templateUrl: './dunning-accounting-discuss.component.html',
	imports: [TranslateDirective, LoaderSpinnerComponent, CommentsBlockComponent, AsyncPipe]
})
export class DunningAccountingDiscussComponent {
	@Input() title = 'Comments.Title';
	@Input() comments$: Observable<ICommentItem[]>;
	@Input() loader = Loader.empty();
	@Output() action = new EventEmitter<IAction>()

	onSubmit(event: ICommentItem) {
		this.action.emit({ type: ActionType.SUBMIT, value: event });
	}

	onClose() {
		this.action.emit({ type: ActionType.CLOSE });
	}
}
